var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 0C1.79418 0 0 1.65441 0 3.6841C0 6.08884 2.28206 8.06918 3.70459 9.86103C3.7729 9.9483 3.88282 10 4 10C4.11718 10 4.2271 9.9483 4.29541 9.86103C5.71809 8.06906 8 6.08884 8 3.6841C8 1.65455 6.2058 0 3.99996 0H4.00004ZM4.00004 0.666701C5.8108 0.666701 7.27281 2.01288 7.27281 3.68394C7.27281 5.56039 5.45054 7.36447 4.00004 9.1214C2.54955 7.36437 0.727281 5.56031 0.727281 3.68394C0.727281 2.01278 2.18927 0.666701 4.00004 0.666701ZM4.00004 2.0104C2.99979 2.0104 2.18184 2.75676 2.18184 3.67015C2.18184 4.58346 2.99979 5.33331 4.00004 5.33331C5.00029 5.33331 5.81824 4.58346 5.81824 3.67015C5.81824 2.75676 5.00029 2.0104 4.00004 2.0104ZM4.00004 2.6771C4.60646 2.6771 5.09092 3.1164 5.09092 3.67017C5.09092 4.22386 4.60644 4.66665 4.00004 4.66665C3.39365 4.66665 2.90917 4.22388 2.90917 3.67017C2.90917 3.1164 3.39365 2.6771 4.00004 2.6771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSmall);
export default __webpack_public_path__ + "static/media/location-small.7d0c78a27719f426079b58b814483f00.svg";
export { ForwardRef as ReactComponent };